import styled, { css } from 'styled-components'

export const CardRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 1.125rem;
  border: 1px solid ${({ theme }) => theme.grey400Color};
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.whiteColor};
`

export const CardLabel = styled.span`
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.grey900Color};
`

export const CardValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
`

export const CardValue = styled.span`
  font-size: 1.875rem;
  line-height: 2.5rem;
  font-weight: 400;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.grey900Color};
`

export const CardDelta = styled.span<{ direction: 'up' | 'down' | 'flat' }>`
  display: inline-flex;
  align-items: center;
  gap: 0.1875rem;
  font-size: 0.75rem;
  font-weight: 600;
  ${({ direction, theme }) => {
    if (direction === 'up')
      return css`
        color: ${theme.successColor};
      `
    if (direction === 'down')
      return css`
        color: ${theme.errorColor};
      `
    return css`
      color: ${theme.grey700Color};
    `
  }}
`
